/**
 * Encore Foundation - 10.25.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Aquamarine 180
 */
export const aquamarine = '#9bf0e1';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Aubergine 46
 */
export const aubergine = '#503750';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Azure 135
 */
export const azure = '#509bf5';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Bole 123
 */
export const bole = '#c87d55';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Bright Red 100
 */
export const brightRed = '#e61e32';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Chocolate 75
 */
export const chocolate = '#7d4b32';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Citric 186
 */
export const citric = '#cdf564';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Electric Seafoam 167
 */
export const electricSeafoam = '#19e68c';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Factory Yellow 184
 */
export const factoryYellow = '#fae62d';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Forest 75
 */
export const forest = '#006450';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Pink 100
 */
export const fuchsia = '#dc148c';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Gold 155
 */
export const gold = '#f59b23';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Klein Blue 61
 */
export const kleinBlue = '#4100f5';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Lavender 135
 */
export const lavender = '#b49bc8';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Maroon 55
 */
export const maroon = '#8c1932';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Midnight 35
 */
export const midnight = '#1e3264';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Neon Green 176
 */
export const neonGreen = '#5ff550';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Pumpkin 135
 */
export const orange = '#ff6437';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Rose 180
 */
export const pink = '#ffcdd2';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Violet Desat 75
 */
export const plum = '#705378';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Powder Green 185
 */
export const powderGreen = '#c3f0c8';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Royal Blue 55
 */
export const royalBlue = '#2d46b9';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Salmon 135
 */
export const salmon = '#f573a0';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Green Blue 100
 */
export const spearmint = '#27856a';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Storm 155
 */
export const storm = '#a0c3d2';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Sunflower 172
 */
export const sunflower = '#ffc864';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Tan 135
 */
export const tan = '#c39687';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Red Orange 100
 */
export const tangerine = '#e3230e';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated, consider moving to Violet 84
 */
export const violet = '#af2896';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray7 = '#121212';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray10 = '#181818';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray15 = '#282828';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray20 = '#333333';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray30 = '#535353';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray50 = '#7f7f7f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray70 = '#b3b3b3';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray80 = '#cccccc';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray85 = '#d9d9d9';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray90 = '#eeeeee';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gray95 = '#f8f8f8';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack0 = 'rgba(0, 0, 0, 0)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack10 = 'rgba(0, 0, 0, 0.1)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack30 = 'rgba(0, 0, 0, 0.3)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack50 = 'rgba(0, 0, 0, 0.5)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack60 = 'rgba(0, 0, 0, 0.6)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack70 = 'rgba(0, 0, 0, 0.7)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityBlack90 = 'rgba(0, 0, 0, 0.9)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite0 = 'rgba(255, 255, 255, 0)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite10 = 'rgba(255, 255, 255, 0.1)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite30 = 'rgba(255, 255, 255, 0.3)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite50 = 'rgba(255, 255, 255, 0.5)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite60 = 'rgba(255, 255, 255, 0.6)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite70 = 'rgba(255, 255, 255, 0.7)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const opacityWhite90 = 'rgba(255, 255, 255, 0.9)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 0
 */
export const black0 = 'rgba(0, 0, 0, 0)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 10
 */
export const black10 = 'rgba(0, 0, 0, 0.1)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 30
 */
export const black30 = 'rgba(0, 0, 0, 0.3)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 50
 */
export const black50 = 'rgba(0, 0, 0, 0.5)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 60
 */
export const black60 = 'rgba(0, 0, 0, 0.6)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 70
 */
export const black70 = 'rgba(0, 0, 0, 0.7)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity Black 90
 */
export const black90 = 'rgba(0, 0, 0, 0.9)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 0
 */
export const white0 = 'rgba(255, 255, 255, 0)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 10
 */
export const white10 = 'rgba(255, 255, 255, 0.1)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 30
 */
export const white30 = 'rgba(255, 255, 255, 0.3)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 50
 */
export const white50 = 'rgba(255, 255, 255, 0.5)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 60
 */
export const white60 = 'rgba(255, 255, 255, 0.6)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 70
 */
export const white70 = 'rgba(255, 255, 255, 0.7)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 90
 */
export const white90 = 'rgba(255, 255, 255, 0.9)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either Opacity Black 10 or Opacity Black 30
 */
export const black20 = 'rgba(0, 0, 0, 0.2)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either Opacity Black 30 or Opacity Black 50
 */
export const black40 = 'rgba(0, 0, 0, 0.4)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to Opacity White 10
 */
export const white5 = 'rgba(255, 255, 255, 0.05)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either Opacity White 10 or Opacity White 30
 */
export const white20 = 'rgba(255, 255, 255, 0.2)';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This opacity is deprecated, consider moving to either Opacity White 30 or Opacity White 50
 */
export const white40 = 'rgba(255, 255, 255, 0.4)';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const solidBlack0 = '#000000';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const solidWhite200 = '#ffffff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spotifyBlack7 = '#121212';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const midnight35 = '#202f72';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const aubergine46 = '#503659';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const maroon55 = '#8a202b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const royalBlue55 = '#283ea3';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const kleinBlue61 = '#4100f4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const forest75 = '#056952';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const chocolate75 = '#834f34';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet84 = '#b02897';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brightRed100 = '#e91429';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spearmint114 = '#4b917d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fuchsia115 = '#f036a4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const tangerine120 = '#ff4834';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const bole123 = '#c87d55';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const salmon135 = '#ef77a1';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const lavender135 = '#af93c4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const azure135 = '#59a0f6';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pumpkin135 = '#ff7439';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const tan135 = '#c19384';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const storm155 = '#a5bbd1';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const gold155 = '#ffa42b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const spotifyGreen157 = '#1ed760';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const sunflower172 = '#ffc862';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const rose180 = '#ffd2d7';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const aquamarine180 = '#91eeda';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const factoryYellow184 = '#fce54f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const powderGreen185 = '#c5f0c9';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const citric186 = '#cff56a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const neonGreen176 = '#5ff550';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const electricSeafoam167 = '#19e68c';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange25 = '#560f00';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange55 = '#911600';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange75 = '#b71800';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange100 = '#e81b00';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange120 = '#ff4834';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange135 = '#ff7163';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange155 = '#ff9e95';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redOrange180 = '#ffd3cf';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown25 = '#3d2418';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown55 = '#683e2a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown75 = '#834f34';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown100 = '#a96440';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown123 = '#c87d55';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown135 = '#d38e67';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown155 = '#e5ac8a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brown180 = '#f7d7c3';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat25 = '#3b251d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat55 = '#653f32';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat75 = '#805040';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat100 = '#a36652';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat135 = '#c19384';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat155 = '#d2b1a6';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownDesat180 = '#eadad5';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange25 = '#4f1800';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange55 = '#862800';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange75 = '#a83200';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange100 = '#d64000';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange135 = '#ff7439';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange155 = '#ffa178';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const orange180 = '#ffd4c2';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow25 = '#491e00';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow55 = '#793500';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow75 = '#964400';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow100 = '#bc5900';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow135 = '#f47e00';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow155 = '#ffa42b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow172 = '#ffc862';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellow180 = '#ffd97e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat25 = '#39260e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat55 = '#624218';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat75 = '#7c531e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat100 = '#9f6b27';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat135 = '#d0913f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat155 = '#deb076';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const brownYellowDesat180 = '#efdabf';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow25 = '#352901';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow55 = '#594602';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow75 = '#705903';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow100 = '#8e7203';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow135 = '#bd9a03';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow155 = '#dab503';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellow184 = '#fce54f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen25 = '#222e03';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen55 = '#3b4f05';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen75 = '#4a6406';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen100 = '#5f8008';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen135 = '#80ac0b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen155 = '#95c90d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreen186 = '#cff56a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat25 = '#262d11';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat55 = '#414d1e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat75 = '#526226';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat100 = '#697d30';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat135 = '#8da841';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat155 = '#a9c261';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const yellowGreenDesat180 = '#d7e3b5';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green25 = '#073116';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green55 = '#0c5426';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green75 = '#0f6a2f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green100 = '#13873c';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green135 = '#19b551';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green157 = '#1ed760';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const green180 = '#96f0b6';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat25 = '#182f21';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat55 = '#265135';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat75 = '#2d6740';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat100 = '#34854d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat135 = '#3db35e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat155 = '#5cce77';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenDesat185 = '#c5f0c9';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue25 = '#013126';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue55 = '#035341';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue75 = '#056952';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue100 = '#088569';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue135 = '#10b28e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue155 = '#16d0a6';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlue180 = '#91eeda';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat25 = '#182e28';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat55 = '#294f44';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat75 = '#346557';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat100 = '#43816f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat114 = '#4b917d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat135 = '#5eac96';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat155 = '#8bc3b3';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const greenBlueDesat180 = '#c9e3db';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue25 = '#052a56';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue55 = '#084791';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue75 = '#0a59b8';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue100 = '#0d72ea';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue135 = '#59a0f6';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue146 = '#73aff7';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue155 = '#89bcf8';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blue180 = '#c8e0fc';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat25 = '#1d2b3a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat55 = '#324b64';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat75 = '#405e7e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat100 = '#5179a1';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat135 = '#82a1c0';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat155 = '#a5bbd1';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueDesat180 = '#d4dfe9';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet25 = '#26008d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet55 = '#3c00e4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet61 = '#4100f4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet75 = '#5925ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet100 = '#7358ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet135 = '#9691ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet155 = '#afb1ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueViolet180 = '#d7dbff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat25 = '#1b2658';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat35 = '#202f72';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat55 = '#283ea3';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat75 = '#334fcd';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat100 = '#576dd6';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat135 = '#8a9ae3';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat155 = '#aab6ea';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const blueVioletDesat180 = '#d7dcf5';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet25 = '#400073';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet55 = '#6900ba';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet75 = '#8400e7';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet100 = '#a833ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet135 = '#c87dff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet155 = '#d8a3ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violet180 = '#edd4ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat25 = '#35243a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat46 = '#503659';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat75 = '#734d85';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat100 = '#8e65a9';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat135 = '#af93c4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat155 = '#c4b1d4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetDesat180 = '#e3daeb';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink25 = '#4c1141';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink55 = '#801d6d';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink75 = '#a1258a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink84 = '#b02897';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink100 = '#cc2faf';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink135 = '#e079cd';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink155 = '#e9a1dc';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPink180 = '#f5d3ef';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat25 = '#3c1c4c';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat55 = '#673081';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat67 = '#773796';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat100 = '#9e57bf';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat135 = '#bb8dd0';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat155 = '#cdaddc';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const violetPinkDesat180 = '#e7d9ed';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink25 = '#550635';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink55 = '#8d0b58';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink75 = '#b00d6e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink100 = '#df118b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink115 = '#f036a4';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink135 = '#f46ebe';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink155 = '#f79bd2';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pink180 = '#fcd2eb';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat25 = '#4c172a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat55 = '#871f43';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat75 = '#ad2152';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat100 = '#de2666';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat135 = '#ef77a1';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat155 = '#f1a2bc';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const pinkDesat180 = '#f4d6df';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red25 = '#590810';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red55 = '#930d1a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red75 = '#b81021';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red100 = '#e91429';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red135 = '#f97481';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red155 = '#fe9da7';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const red180 = '#ffd2d7';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat25 = '#521319';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat55 = '#8a202b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat75 = '#ad2836';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat100 = '#d33f4e';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat135 = '#e2828c';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat155 = '#eaa6ad';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const redDesat180 = '#f5d6d9';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. Implement third-party brand colors like Facebook locally and consider using their logo/icon instead for login scenarios. If you have any questions, please reach out in #encore
 */
export const blueFacebook100 = '#2374e1';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentRed109 = '#ff001a';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentOrange144 = '#ff8b1f';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentYellow194 = '#f3ff46';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentGreen176 = '#5ff550';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentGreenBlue167 = '#19e68c';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentCyan185 = '#00ffff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentBlueViolet69 = '#2d28ff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentViolet111 = '#c13fff';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const fluorescentPink119 = '#ff1abf';

/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
export const wrappedBlue139 = '#00aeef';

/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
export const wrappedYellow190 = '#fff200';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const green = '#1db954';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const greenLight = '#1ed760';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const greenFocus = '#1da64d';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the bright accent or positive colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const greenDark = '#14833b';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const black = '#000000';

/**
 *
 * ![Status: production](https://img.shields.io/badge/PRODUCTION-green|height=14)
 */
export const white = '#ffffff';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const red = '#cd1a2b';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const redLight = '#e22134';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the negative colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const redDark = '#941320';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const blue = '#2e77d0';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const blueLight = '#4687d6';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated Use blue-facebook-100 instead. This version of the facebook-blue has been subtly tweaked to have accessible contrast with white text. If you need a different shade, please reach out in #encore
 */
export const blueFacebook = '#1877f2';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the announcement colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const blueDark = '#1d4c85';

/**
 *
 * ![Status: deprecated](https://img.shields.io/badge/DEPRECATED-red|height=14)
 * @deprecated This color is deprecated. You can achieve similar results with the warning colors and color sets in color themes. Learn more at https://encore.spotify.net/foundation/basics/color-themes
 */
export const orangeLight = '#ff5722';
